module.exports = __webpack_public_path__ + "static/media/social-windows.ae7a26a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth/social-windows.svg
// module id = 225
// module chunks = 0